import { Directive, ElementRef, inject, input } from '@angular/core';
import type { UntypedFormGroup } from '@angular/forms';

@Directive({
  standalone: true,
  selector: '[rtQuestionRef]',
  exportAs: 'rtQuestionRef',
})
export class QuestionRefDirective {
  public readonly elRef = inject(ElementRef);
  public readonly questionForm = input<UntypedFormGroup>(undefined!);
}
